export default __webpack_public_path__ + "static/media/strongIcon.a5667f4e.svg";